button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: none;
    cursor: pointer;

    &:hover {
        opacity: 70%;
    }

    &:disabled {
        cursor: default;
        opacity: 60%;
    }



    &.size-sm {
        width: 14px;
        height: 14px;

        @include breakpointMin('md') {
            width: 30px;
            height: 30px;
        }
    }

    &.size-md {
        width: 30px;
        height: 30px;
    }

    &.size-lg {
        width: 35px;
        height: 35px;
    }


    &.nero { background-color: var(--color-nero); }
    &.white { background-color: var(--color-white); }
    &.silver { background-color: var(--color-silver); }
    &.bleached-silk { background-color: var(--color-bleached-silk); }
    &.anthrazit { background-color: var(--color-livique-anthrazit); }
    &.cherryade { background-color: var(--color-livique-cherryade); }
    &.green-seduction { background-color: var(--color-livique-green-seduction); }

    &.mansory {
        box-shadow: 0 0px 10px 0 #c4c4c4;
        opacity: 1;

        &:hover {
            cursor: pointer;
            box-shadow: 0 0 0 0 rgba(var(--color-white-anthrazit), .5);
            background-color: var(--color-white);
            opacity: 1;

            &:before,
            &:after {
                content: "";
                position: absolute;
                height: 100%;
                width: 100%;
                background-color: var(--color-white);
                border-radius: 50%;
                z-index: -1;
                opacity: 0.7;
            }

            &:before {
                animation: pulse 2s ease-out infinite;
            }

            &:after {
                animation: pulse 2s 1s ease-out infinite;
            }
        }
    }


    @keyframes pulse {
        100% {
            transform: scale(2.5);
            opacity: 0;
        }
    }
}


